__turbopack_context__.v({
  "captionWrapper": "FEM1gW_captionWrapper",
  "featuredImage": "FEM1gW_featuredImage",
  "featuredImageAccess": "FEM1gW_featuredImageAccess",
  "featuredImageContainer": "FEM1gW_featuredImageContainer",
  "featuredImageContext": "FEM1gW_featuredImageContext",
  "featuredImageMeta": "FEM1gW_featuredImageMeta",
  "figure": "FEM1gW_figure",
  "imageAndControls": "FEM1gW_imageAndControls",
  "imageAndRightsContainer": "FEM1gW_imageAndRightsContainer",
  "isButton": "FEM1gW_isButton",
  "isRestricted": "FEM1gW_isRestricted",
  "noAdditionalImages": "FEM1gW_noAdditionalImages",
  "noFeaturedImageImage": "FEM1gW_noFeaturedImageImage",
  "noFeaturedImageMessage": "FEM1gW_noFeaturedImageMessage",
  "rightsRestrictedMessageWrapper": "FEM1gW_rightsRestrictedMessageWrapper",
  "rtl": "FEM1gW_rtl",
  "rtlText": "FEM1gW_rtlText",
  "selectedThumbnail": "FEM1gW_selectedThumbnail",
  "shelfContainer": "FEM1gW_shelfContainer",
  "thumbnail": "FEM1gW_thumbnail",
  "wrapper": "FEM1gW_wrapper",
});
